import React, { useState } from 'react';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

const sections = [
  { id: 'core', label: 'Basic Info', icon: Icon.User },
  // { id: 'llm', label: 'LLM', icon: Icon.Cpu },
  { id: 'voice_speech', label: 'Voice & Speech', icon: Icon.Volume2 },
  // { id: 'call_behavior', label: 'Call Behavior', icon: Icon.Phone },
  { id: 'analysis_schema', label: 'Analysis Schema', icon: Icon.List },
  { id: 'advanced', label: 'Advanced', icon: Icon.Settings }
];

const CallexAiAgentSettingsPage = ({ handleSubmit, children, validateForm }) => {
  const [active, setActive] = useState('core');

  const activeSection = sections.find((s) => s.id === active);
  const ActiveIcon = activeSection?.icon;

  const findErrorSection = (errors) => {
    if (
      errors.name ||
      errors.description ||
      errors.systemPrompt ||
      errors.openingLine ||
      errors.voice ||
      errors.language ||
      errors.status
    )
      return 'core';
    // if (errors.temperature || errors.maxTokens || errors.sttEngine || errors.llmModel) return 'llm';
    if (
      // errors.prosodyRate ||
      // errors.prosodyPitch ||
      errors.fillerPhrases ||
      errors.speakingStyle ||
      errors.backgroundAmbience
    )
      return 'voice_speech';
    // if (errors.bargeInMode || errors.patienceMs || errors.maxDuration || errors.ringTimeout || errors.voicemailLogic || errors.fallbackMessage) return 'call_behavior';
    if (errors.analysisSchema) return 'analysis_schema';
    if (
      errors.sentimentRouting ||
      errors.piiRedaction ||
      errors.emotionalMirroring ||
      errors.dynamicCodeSwitching ||
      errors.objectionHandling ||
      errors.autoSummary ||
      errors.autoSentiment ||
      errors.recordCall ||
      errors.webhookUrl ||
      errors.autoFollowUp
    )
      return 'advanced';

    return null;
  };

  return (
    <div className="ai-settings-page">
      <div className="settings-layout">
        <div className="settings-sidebar">
          {sections.map((section) => {
            const IconComponent = section.icon;
            return (
              <div
                key={section.id}
                className={`sidebar-item ${active === section.id ? 'active' : ''}`}
                onClick={() => setActive(section.id)}>
                <IconComponent size={16} />
                <span>{section.label}</span>
              </div>
            );
          })}
        </div>

        <div className="settings-content">
          {/* HEADER */}
          <div className="settings-header">
            {ActiveIcon && <ActiveIcon size={16} />}
            <h6>{activeSection?.label}</h6>
          </div>

          {/* FORM CONTENT */}
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              const formErrors = await validateForm();
              console.log('formErrors', formErrors);
              if (Object.keys(formErrors).length > 0) {
                const errorTab = findErrorSection(formErrors);
                if (errorTab) {
                  setActive(errorTab);
                  toast.error('Please complete all required fields.');
                }
              }
              handleSubmit();
            }}
            id="callex-ai-agent-form">
            {React.Children.map(children, (child) => (child?.props?.id === active ? child : null))}
          </form>
        </div>
      </div>
    </div>
  );
};

CallexAiAgentSettingsPage.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
  validateForm: PropTypes.any
};

export default CallexAiAgentSettingsPage;
